/**
 * Sign In Modal Component
 * ========================
 * ChatGPT-style modal prompting users to sign in or continue without signing in
 * Displays after the first prompt for non-authenticated users
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SignInModal({ isOpen, onClose, onContinueWithoutSignIn }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignIn = () => {
    navigate('/login');
  };

  const handleSignUp = () => {
    navigate('/login'); // The login page has both sign in and sign up
  };

  const handleContinue = () => {
    onContinueWithoutSignIn();
    onClose();
  };

  return (
    <div className="signin-modal-overlay" onClick={onClose}>
      <div className="signin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="signin-modal-content">
          <h2>Get the most out of Marketing Genius</h2>
          <p className="signin-modal-description">
            Log in or sign up to get smarter responses, save your conversations, 
            and access advanced features.
          </p>

          <div className="signin-modal-benefits">
            <div className="benefit-item">
              <span className="benefit-icon">💾</span>
              <span className="benefit-text">Save and manage your projects</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🚀</span>
              <span className="benefit-text">Access advanced AI features</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">📊</span>
              <span className="benefit-text">Get detailed analytics and reports</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🎯</span>
              <span className="benefit-text">Implement strategies via marketplace</span>
            </div>
          </div>

          <div className="signin-modal-actions">
            <button 
              className="btn-primary signin-btn"
              onClick={handleSignIn}
            >
              Log in
            </button>
            <button 
              className="btn-secondary signup-btn"
              onClick={handleSignUp}
            >
              Sign up for free
            </button>
          </div>

          <button 
            className="btn-text continue-btn"
            onClick={handleContinue}
          >
            Stay logged out
          </button>

          <p className="signin-modal-limit-notice">
            Without an account, you can ask <strong>2 more questions</strong> (3 total).
          </p>
        </div>
      </div>
    </div>
  );
}

